// components/modals/addSignaturePopUp/index.tsx
import React, {FC, useContext} from 'react';
import { AddSignaturePopUpProps } from './types';
import {AuthContext} from "../../../../context/authContext";
import {useNavigate} from "react-router-dom";

const AddSignaturePopUp: FC<AddSignaturePopUpProps> = ({ isOpen, onClose, onSignatureAdded }) => {
    const { userData } = useContext(AuthContext);
    const navigate = useNavigate();

    if (!isOpen) return null;

    return (
        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            tabIndex={-1}
            role="dialog"
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose(); // close on backdrop click
                }
            }}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content position-relative">
                    <button
                        type="button"
                        className="btn-close position-absolute top-0 end-0 m-3"
                        style={{ zIndex: 2 }}
                        aria-label="Close"
                        onClick={(e) => {
                            console.log("onClose func called")
                            // e.stopPropagation(); // prevent bubbling to backdrop
                            onClose();
                        }}
                    ></button>

                    <div className="modal-body">
                        <div className="text-center">
                            <i className="bi bi-pen-fill text-primary fs-1"></i>
                            <h3 className="mt-3">Add Digital Signature</h3>
                            <p className="fs-6">
                                mannkindCares has added a new signature capture feature to allow for a more robust
                                ordering platform.  Below, you can see the Prescriber(s) that require a signature
                                attached to their profile. You can have the corresponding Prescriber sign the screen
                                or upload an image of the signature through the interface.  If you choose to skip for
                                now, you will be required to add a signature for the corresponding Prescriber during
                                your next patient enrollment.  You can always update or add signatures within the
                                dropdown in the top right of the screen, at any point. If you have any questions,
                                please feel free to call us directly.
                            </p>

                            <button
                                type="button"
                                className="btn btn-primary mt-3"
                                onClick={() => {
                                    if (userData?.ref_type !== "GlobalDoctor") {
                                        navigate("/pages/signaturemanagement");
                                    } else {
                                        onClose();
                                        onSignatureAdded();
                                    }
                                }}
                            >
                                Add Signature
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary mt-3 ms-2"
                                onClick={() => {
                                    onClose();
                                }}
                            >
                                Skip for now
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddSignaturePopUp;
